import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
    const [click, setClick] = useState(false);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 960) {
                closeMobileMenu();
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <nav className="navbar">
                <div className="navbar-container">
                    <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
                        <img src="/logo192.png" alt="boom chr paige" width="30" height="30" />&nbsp;boomchrpaige
                    </Link>
                    <div className="menu-icon" onClick={handleClick}>
                        <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
                    </div>
                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                    <li className='nav-item'>
                    <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                        Home
                    </Link>
                    </li>
                    <li className='nav-item'>
                    <Link
                        to='/about'
                        className='nav-links'
                        onClick={closeMobileMenu}
                    >
                        About
                    </Link>
                    </li>
                    <li className='nav-item'>
                    <Link
                        to='/releases'
                        className='nav-links'
                        onClick={closeMobileMenu}
                    >
                        Releases
                    </Link>
                    </li>
                    <li className='nav-item'>
                    <Link
                        to='/contact'
                        className='nav-links'
                        onClick={closeMobileMenu}
                    >
                        Contact
                    </Link>
                    </li>
                    </ul>
                </div>
            </nav>
        </>
    )
}

export default Navbar
